// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Invoice_PlanoParaOrdemServicoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /subaccounts/invoices/plano-para-ordem-servico/{so_order_id}
 * (routed to subaccounts/invoice_triggers/plano_para_ordem_servico).
 *
 * Pre-flight preview: which fiscal document(s) this Service Order would
 * generate and why each one can or cannot be emitted right now — WITHOUT
 * emitting anything. Source: InvoiceService::planoParaOrdemServico(), which
 * calls the exact same InvoiceService::avaliarEmissaoParaOrdemServico() that
 * InvoiceService::emitirParaOrdemServico() consults before emitting for
 * real — see that method's docblock for why this is the single source of
 * truth both paths share.
 */
import type { Invoice_PlanoBlockingReasonRow } from './Invoice_PlanoBlockingReasonRow'
import type { Invoice_PlanoDocumentoRow } from './Invoice_PlanoDocumentoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Invoice_PlanoParaOrdemServicoResponseDados {
so_order_id: number
franchise_id: number
country: string
can_emit: boolean
product_items_without_invoice_count: number
planner_note: string
blocking_reasons: Invoice_PlanoBlockingReasonRow[]
documents: Invoice_PlanoDocumentoRow[]
}

export type Invoice_PlanoParaOrdemServicoResponse = ApiResponse<Invoice_PlanoParaOrdemServicoResponseDados>;

registerResponseContract('Invoice_PlanoParaOrdemServicoResponse', {
  so_order_id:                         { type: 'number',  required: true },
  franchise_id:                        { type: 'number',  required: true },
  country:                             { type: 'string',  required: false },
  can_emit:                            { type: 'boolean', required: true },
  product_items_without_invoice_count: { type: 'number',  required: true },
  planner_note:                        { type: 'string',  required: false },
  blocking_reasons: {
    type: 'array',
    required: true,
    items: {
      code:     { type: 'string',  required: false },
      message:  { type: 'string',  required: false },
      severity: { type: 'string',  required: false },
    },
  },
  documents: {
    type: 'array',
    required: true,
    items: {
      document_kind:    { type: 'string',  required: false },
      item_count:       { type: 'number',  required: false },
      total_amount:     { type: 'number',  required: false },
      tax_amount:       { type: 'number',  required: false },
      taxless_amount:   { type: 'number',  required: false },
      blocking_reasons: {
        type: 'array',
        required: false,
        items: {
          code:     { type: 'string',  required: false },
          message:  { type: 'string',  required: false },
          severity: { type: 'string',  required: false },
        },
      },
    },
  },
})
